import { Directive, ElementRef, Input, AfterViewInit, HostListener, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

// Bootstrap needs to be globally available for this to work
declare var bootstrap: any;

@Directive({
  selector: '[toggle],toggle',
  standalone: false
})
export class PopupDirective implements AfterViewInit, OnChanges, OnDestroy {
  @Input() toggle: string;
  @Input() container: string;
  @Input() title: string;
  @Input() content: string;
  @Input() placement: string;

  private popoverInstance: any;
  private viewReady = false;

  constructor(private readonly el: ElementRef) {}

  ngAfterViewInit() {
    this.viewReady = true;
    this.syncPopover();
  }

  // The panchang day cells fill `content` asynchronously (after the
  // availability fetch and calculateWeeks). The old one-shot ngAfterViewInit
  // never saw the late value, so the popover was never created and hover
  // showed nothing. Re-sync whenever toggle/content/title change.
  ngOnChanges(changes: SimpleChanges) {
    if (!this.viewReady) {
      return;
    }
    this.syncPopover();
  }

  private syncPopover() {
    if (this.toggle === 'popover') {
      if (this.popoverInstance) {
        // Recreate so late content/title updates are reflected (setContent is
        // unreliable across the bundled bootstrap version for html popovers).
        this.popoverInstance.dispose();
      }
      this.popoverInstance = new bootstrap.Popover(this.el.nativeElement, {
        title: this.title || '',
        content: this.content || '',
        placement: this.placement || 'right',
        trigger: 'manual',
        html: true,
        container: this.container || 'body',
        sanitize: false
      });
    } else if (this.popoverInstance) {
      this.popoverInstance.dispose();
      this.popoverInstance = null;
    }
  }

  @HostListener('mouseenter')
  mouseenter() {
    if (this.toggle === 'popover' && this.popoverInstance) {
      this.popoverInstance.show();
    }
  }

  @HostListener('mouseleave')
  mouseleave() {
    if (this.toggle === 'popover' && this.popoverInstance) {
      this.popoverInstance.hide();
    }
  }

  ngOnDestroy() {
    if (this.popoverInstance) {
      this.popoverInstance.dispose();
    }
  }
}
